var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_41174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 7.99844C11 7.44844 10.55 6.99844 10 6.99844H3C2.45 6.99844 2 7.44844 2 7.99844C2 8.54844 2.45 8.99844 3 8.99844H10C10.55 8.99844 11 8.54844 11 7.99844ZM11 15.9984C11 15.4484 10.55 14.9984 10 14.9984H3C2.45 14.9984 2 15.4484 2 15.9984C2 16.5484 2.45 16.9984 3 16.9984H10C10.55 16.9984 11 16.5484 11 15.9984ZM17.05 10.2884C16.66 10.6784 16.03 10.6784 15.64 10.2884L13.52 8.16844C13.13 7.77844 13.13 7.14844 13.52 6.75844C13.91 6.36844 14.54 6.36844 14.93 6.75844L16.34 8.16844L19.88 4.62844C20.27 4.23844 20.9 4.23844 21.29 4.62844C21.68 5.01844 21.68 5.64844 21.29 6.03844L17.05 10.2884ZM17.05 18.2884C16.66 18.6784 16.03 18.6784 15.64 18.2884L13.52 16.1684C13.13 15.7784 13.13 15.1484 13.52 14.7584C13.91 14.3684 14.54 14.3684 14.93 14.7584L16.34 16.1684L19.88 12.6284C20.27 12.2384 20.9 12.2384 21.29 12.6284C21.68 13.0184 21.68 13.6484 21.29 14.0384L17.05 18.2884Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_41174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.49216fc7.svg";
export { ForwardRef as ReactComponent };